// extracted by mini-css-extract-plugin
export var configurationSection = "_z4-0";